export default "__VITE_ASSET__cb323af1__"